export default __webpack_public_path__ + "static/mobile-3680969e48a2ac79fec3a426ce34e5ae.svg";